export { default } from "./details-field-title";
